import React from 'react'
import * as Modal from '../../common/components/modal/modalDialog';
import Dialog from '@material-ui/core/Dialog';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";

const ScenePopupComponent = (props: any) => {
    const theme = createMuiTheme({
        overrides: {
            MuiDialog: {
                paperWidthSm: {
                    maxWidth: '80%'
                }
            },
            MuiDialogTitle: {
                root: {
                    borderBottom: 'none !important',
                    marginBottom: 10
                }
            }
        }
    });

    return (
        <MuiThemeProvider theme={theme}>
            <Dialog
                open={props.isVisible}
                onClose={props.handleCancelButton}
            >
                <Modal.DialogTitle onClose={props.handleCancelButton}><div>{props.title}</div></Modal.DialogTitle>
                <Modal.DialogContent>
                    <div className="popup-container">
                        {props.content}
                    </div>
                </Modal.DialogContent>
                {props.actions ?
                    <Modal.DialogActions>
                        {props.actions}
                    </Modal.DialogActions>
                    : null}
            </Dialog>
        </MuiThemeProvider>
    )

}

export default ScenePopupComponent;
